import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface AddProductInput {
  orderId: string;
  barcode: string;
  name: string;
  boxes: number;
  unitsPerBox: number;
  photos: string[];
  creationSource?: string;
}

export const useProductMutations = (orderId: string) => {
  const queryClient = useQueryClient();

  const addProduct = useMutation({
    mutationFn: async (input: AddProductInput) => {
      const payload: any = {
        order_id: input.orderId,
        barcode: input.barcode,
        name: input.name,
        boxes: input.boxes,
        units_per_box: input.unitsPerBox,
        photos: input.photos,
        creation_source: input.creationSource || "manual",
      };
      const { data, error } = await supabase.from("products").insert(payload).select("*").single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products", orderId] });
    },
  });

  const deleteProduct = useMutation({
    mutationFn: async (productId: string) => {
      const { error } = await supabase.from("products").delete().eq("id", productId);
      if (error) throw error;
      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products", orderId] });
    },
  });

  return { addProduct, deleteProduct };
};
